export enum EmploymentStatusEnum {
	Active = 0,

	Terminated = 1,

	LeaveOfAbsence = 2
}

export enum EmploymentStatusTextEnum {
	Active = 'Active',

	Terminated = 'Terminated',

	LeaveOfAbsence = 'Leave Of Absence'
}
